<div *ngIf="profileData" class="mct-gap-16 mct-grid-gt-sm mct-cols-1-1-gt-sm">
  <div class="mct-flex mct-col mct-gap-5 mct-col-1-span-2-gt-sm mt-16" *ngIf="isOrg">
    <div class="mct-flex mct-justify-between mct-items-center">
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox name="DisplayOrgName" [(ngModel)]="profileData.DisplayOrgName" [binary]="true" inputId="displayOrgName"> </p-checkbox>
        <label for="displayOrgName">
          {{ 'common.personal-information.organization-name' | translate | titlecase }}
        </label>
      </div>
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox
          name="RequireOrgName"
          [(ngModel)]="profileData.RequireOrgName"
          [binary]="true"
          inputId="requireOrgName"
          class="mini-checkbox"
        >
        </p-checkbox>
        <label for="requireOrgName" class="mr-5">
          {{ 'common.required' | translate | titlecase }}
        </label>
      </div>
    </div>
    <input name="OrgNameLabel" class="form-control" type="text" [(ngModel)]="profileData.OrgNameLabel" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mt-16" *ngIf="!isOrg">
    <div class="mct-flex mct-justify-between mct-items-center">
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox name="DisplayFirstName" [(ngModel)]="profileData.DisplayFirstName" [binary]="true" inputId="displayFirstName">
        </p-checkbox>
        <label for="displayFirstName">
          {{ 'common.personal-information.first-name' | translate | titlecase }}
        </label>
      </div>
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox
          name="RequireFirstName"
          [(ngModel)]="profileData.RequireFirstName"
          [binary]="true"
          inputId="requireFirstName"
          class="mini-checkbox"
        >
        </p-checkbox>
        <label for="requireFirstName" class="mr-5">
          {{ 'common.required' | translate | titlecase }}
        </label>
      </div>
    </div>
    <input name="FirstNameLabel" class="form-control" type="text" [(ngModel)]="profileData.FirstNameLabel" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mct-gap-5 mt-16" *ngIf="!isOrg">
    <div class="mct-flex mct-justify-between mct-items-center">
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox name="DisplayLastName" [(ngModel)]="profileData.DisplayLastName" [binary]="true" inputId="displayLastName"> </p-checkbox>
        <label for="displayLastName">
          {{ 'common.personal-information.last-name' | translate | titlecase }}
        </label>
      </div>
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox
          name="RequireLastName"
          [(ngModel)]="profileData.RequireLastName"
          [binary]="true"
          inputId="requireLastName"
          class="mini-checkbox"
        >
        </p-checkbox>
        <label for="requireLastName" class="mr-5">
          {{ 'common.required' | translate | titlecase }}
        </label>
      </div>
    </div>
    <input name="LastNameLabel" class="form-control" type="text" [(ngModel)]="profileData.LastNameLabel" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mct-gap-5 mt-16" *ngIf="!isOrg">
    <div class="mct-flex mct-justify-between mct-items-center">
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox name="DisplayMiddleInitial" [(ngModel)]="profileData.DisplayMiddleInitial" [binary]="true" inputId="displayMiddleInitial">
        </p-checkbox>
        <label for="displayMiddleInitial">
          {{ 'common.personal-information.middle-initial' | translate | titlecase }}
        </label>
      </div>
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox
          name="RequireMiddleInitial"
          [(ngModel)]="profileData.RequireMiddleInitial"
          [binary]="true"
          inputId="requireMiddleInitial"
          class="mini-checkbox"
        >
        </p-checkbox>
        <label for="requireMiddleInitial" class="mr-5">
          {{ 'common.required' | translate | titlecase }}
        </label>
      </div>
    </div>
    <input name="MiddleInitialLabel" class="form-control" type="text" [(ngModel)]="profileData.MiddleInitialLabel" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mct-gap-5 mt-16" *ngIf="!isOrg">
    <div class="mct-flex mct-justify-between mct-items-center">
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox name="DisplayPrefix" [(ngModel)]="profileData.DisplayPrefix" [binary]="true" inputId="displayPrefix"> </p-checkbox>
        <label for="displayPrefix">
          {{ 'common.personal-information.prefix' | translate | titlecase }}
        </label>
      </div>
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox
          name="RequirePrefix"
          [(ngModel)]="profileData.RequirePrefix"
          [binary]="true"
          inputId="requirePrefix"
          class="mini-checkbox"
        >
        </p-checkbox>
        <label for="requirePrefix" class="mr-5">
          {{ 'common.required' | translate | titlecase }}
        </label>
      </div>
    </div>
    <input name="PrefixLabel" class="form-control" type="text" [(ngModel)]="profileData.PrefixLabel" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mct-gap-5 mt-16" *ngIf="!isOrg">
    <div class="mct-flex mct-justify-between mct-items-center">
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox name="DisplaySuffix" [(ngModel)]="profileData.DisplaySuffix" [binary]="true" inputId="displaySuffix"> </p-checkbox>
        <label for="displaySuffix">
          {{ 'common.personal-information.suffix' | translate | titlecase }}
        </label>
      </div>
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox
          name="RequireSuffix"
          [(ngModel)]="profileData.RequireSuffix"
          [binary]="true"
          inputId="requireSuffix"
          class="mini-checkbox"
        >
        </p-checkbox>
        <label for="requireSuffix" class="mr-5">
          {{ 'common.required' | translate | titlecase }}
        </label>
      </div>
    </div>
    <input name="SuffixLabel" class="form-control" type="text" [(ngModel)]="profileData.SuffixLabel" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mct-gap-5 mt-16" *ngIf="!isOrg">
    <div class="mct-flex mct-justify-between mct-items-center">
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox name="DisplayTitle" [(ngModel)]="profileData.DisplayTitle" [binary]="true" inputId="displayTitle"> </p-checkbox>
        <label for="displayTitle">
          {{ 'common.personal-information.title' | translate | titlecase }}
        </label>
      </div>
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox name="RequireTitle" [(ngModel)]="profileData.RequireTitle" [binary]="true" inputId="requireTitle" class="mini-checkbox">
        </p-checkbox>
        <label for="requireTitle" class="mr-5">
          {{ 'common.required' | translate | titlecase }}
        </label>
      </div>
    </div>
    <input name="TitleLabel" class="form-control" type="text" [(ngModel)]="profileData.TitleLabel" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mct-gap-5 mt-16">
    <div class="mct-flex mct-justify-between mct-items-center">
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox name="DisplayAddress1" [(ngModel)]="profileData.DisplayAddress1" [binary]="true" inputId="displayAddress1"> </p-checkbox>
        <label for="displayAddress1">
          {{ 'common.personal-information.address1' | translate | titlecase }}
        </label>
      </div>
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox
          name="RequireAddress1"
          [(ngModel)]="profileData.RequireAddress1"
          [binary]="true"
          inputId="requireAddress1"
          class="mini-checkbox"
        >
        </p-checkbox>
        <label for="requireAddress1" class="mr-5">
          {{ 'common.required' | translate | titlecase }}
        </label>
      </div>
    </div>
    <input name="Address1Label" class="form-control" type="text" [(ngModel)]="profileData.Address1Label" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mct-gap-5 mt-16">
    <div class="mct-flex mct-justify-between mct-items-center">
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox name="DisplayAddress2" [(ngModel)]="profileData.DisplayAddress2" [binary]="true" inputId="displayAddress2"> </p-checkbox>
        <label for="displayAddress2">
          {{ 'common.personal-information.address2' | translate | titlecase }}
        </label>
      </div>
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox
          name="RequireAddress2"
          [(ngModel)]="profileData.RequireAddress2"
          [binary]="true"
          inputId="requireAddress2"
          class="mini-checkbox"
        >
        </p-checkbox>
        <label for="requireAddress2" class="mr-5">
          {{ 'common.required' | translate | titlecase }}
        </label>
      </div>
    </div>
    <input name="Address2Label" class="form-control" type="text" [(ngModel)]="profileData.Address2Label" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mct-gap-5 mt-16">
    <div class="mct-flex mct-justify-between mct-items-center">
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox name="DisplayCity" [(ngModel)]="profileData.DisplayCity" [binary]="true" inputId="displayCity"> </p-checkbox>
        <label for="displayCity">
          {{ 'common.personal-information.city' | translate | titlecase }}
        </label>
      </div>
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox name="RequireCity" [(ngModel)]="profileData.RequireCity" [binary]="true" inputId="requireCity" class="mini-checkbox">
        </p-checkbox>
        <label for="requireCity" class="mr-5">
          {{ 'common.required' | translate | titlecase }}
        </label>
      </div>
    </div>
    <input name="CityLabel" class="form-control" type="text" [(ngModel)]="profileData.CityLabel" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mct-gap-5 mt-16">
    <div class="mct-flex mct-justify-between mct-items-center">
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox name="DisplayState" [(ngModel)]="profileData.DisplayState" [binary]="true" inputId="displayState"> </p-checkbox>
        <label for="displayState">
          {{ 'common.personal-information.state' | translate | titlecase }}
        </label>
      </div>
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox name="RequireState" [(ngModel)]="profileData.RequireState" [binary]="true" inputId="requireState" class="mini-checkbox">
        </p-checkbox>
        <label for="requireState" class="mr-5">
          {{ 'common.required' | translate | titlecase }}
        </label>
      </div>
    </div>
    <input name="StateLabel" class="form-control" type="text" [(ngModel)]="profileData.StateLabel" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mct-gap-5 mt-16">
    <div class="mct-flex mct-justify-between mct-items-center">
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox name="DisplayZip" [(ngModel)]="profileData.DisplayZip" [binary]="true" inputId="displayZip"> </p-checkbox>
        <label for="displayZip">
          {{ 'common.personal-information.zip' | translate | titlecase }}
        </label>
      </div>
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox name="RequireZip" [(ngModel)]="profileData.RequireZip" [binary]="true" inputId="requireZip" class="mini-checkbox">
        </p-checkbox>
        <label for="requireZip" class="mr-5">
          {{ 'common.required' | translate | titlecase }}
        </label>
      </div>
    </div>
    <input name="ZipLabel" class="form-control" type="text" [(ngModel)]="profileData.ZipLabel" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mct-gap-5 mt-16">
    <div class="mct-flex mct-justify-between mct-items-center">
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox name="DisplayZipExt" [(ngModel)]="profileData.DisplayZipExt" [binary]="true" inputId="displayZipExt"> </p-checkbox>
        <label for="displayZipExt">
          {{ 'common.personal-information.zipext' | translate | titlecase }}
        </label>
      </div>
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox
          name="RequireZipExt"
          [(ngModel)]="profileData.RequireZipExt"
          [binary]="true"
          inputId="requireZipExt"
          class="mini-checkbox"
        >
        </p-checkbox>
        <label for="requireZipExt" class="mr-5">
          {{ 'common.required' | translate | titlecase }}
        </label>
      </div>
    </div>
    <input name="ZipExtLabel" class="form-control" type="text" [(ngModel)]="profileData.ZipExtLabel" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mct-gap-5 mt-16">
    <div class="mct-flex mct-justify-between mct-items-center">
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox name="DisplayCounty" [(ngModel)]="profileData.DisplayCounty" [binary]="true" inputId="displayCounty"> </p-checkbox>
        <label for="displayCounty">
          {{ 'common.personal-information.county' | translate | titlecase }}
        </label>
      </div>
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox
          name="RequireCounty"
          [(ngModel)]="profileData.RequireCounty"
          [binary]="true"
          inputId="requireCounty"
          class="mini-checkbox"
        >
        </p-checkbox>
        <label for="requireCounty" class="mr-5">
          {{ 'common.required' | translate | titlecase }}
        </label>
      </div>
    </div>
    <input name="CountyLabel" class="form-control" type="text" [(ngModel)]="profileData.CountyLabel" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mct-gap-5 mt-16">
    <div class="mct-flex mct-justify-between mct-items-center">
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox name="DisplayCountry" [(ngModel)]="profileData.DisplayCountry" [binary]="true" inputId="displayCountry"> </p-checkbox>
        <label for="displayCountry">
          {{ 'common.personal-information.country' | translate | titlecase }}
        </label>
      </div>
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox
          name="RequireCountry"
          [(ngModel)]="profileData.RequireCountry"
          [binary]="true"
          inputId="requireCountry"
          class="mini-checkbox"
        >
        </p-checkbox>
        <label for="requireCountry" class="mr-5">
          {{ 'common.required' | translate | titlecase }}
        </label>
      </div>
    </div>
    <input name="CountryLabel" class="form-control" type="text" [(ngModel)]="profileData.CountryLabel" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mct-gap-5 mt-16">
    <div class="mct-flex mct-justify-between mct-items-center">
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox name="DisplayWorkPhone" [(ngModel)]="profileData.DisplayWorkPhone" [binary]="true" inputId="displayWorkPhone">
        </p-checkbox>
        <label for="displayWorkPhone">
          {{ 'common.personal-information.work-phone' | translate | titlecase }}
        </label>
      </div>
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox
          name="RequireWorkPhone"
          [(ngModel)]="profileData.RequireWorkPhone"
          [binary]="true"
          inputId="requireWorkPhone"
          class="mini-checkbox"
        >
        </p-checkbox>
        <label for="requireWorkPhone" class="mr-5">
          {{ 'common.required' | translate | titlecase }}
        </label>
      </div>
    </div>
    <input name="WorkPhoneLabel" class="form-control" type="text" [(ngModel)]="profileData.WorkPhoneLabel" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mct-gap-5 mt-16">
    <div class="mct-flex mct-justify-between mct-items-center">
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox name="DisplayHomePhone" [(ngModel)]="profileData.DisplayHomePhone" [binary]="true" inputId="displayHomePhone">
        </p-checkbox>
        <label for="displayHomePhone">
          {{ 'common.personal-information.home-phone' | translate | titlecase }}
        </label>
      </div>
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox
          name="RequireHomePhone"
          [(ngModel)]="profileData.RequireHomePhone"
          [binary]="true"
          inputId="requireHomePhone"
          class="mini-checkbox"
        >
        </p-checkbox>
        <label for="requireHomePhone" class="mr-5">
          {{ 'common.required' | translate | titlecase }}
        </label>
      </div>
    </div>
    <input name="HomePhoneLabel" class="form-control" type="text" [(ngModel)]="profileData.HomePhoneLabel" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mct-gap-5 mt-16">
    <div class="mct-flex mct-justify-between mct-items-center">
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox name="DisplayCellPhone" [(ngModel)]="profileData.DisplayCellPhone" [binary]="true" inputId="displayCellPhone">
        </p-checkbox>
        <label for="displayCellPhone">
          {{ 'common.personal-information.cell-phone' | translate | titlecase }}
        </label>
      </div>
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox
          name="RequireCellPhone"
          [(ngModel)]="profileData.RequireCellPhone"
          [binary]="true"
          inputId="requireCellPhone"
          class="mini-checkbox"
        >
        </p-checkbox>
        <label for="requireCellPhone" class="mr-5">
          {{ 'common.required' | translate | titlecase }}
        </label>
      </div>
    </div>
    <input name="CellPhoneLabel" class="form-control" type="text" [(ngModel)]="profileData.CellPhoneLabel" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mct-gap-5 mt-16">
    <div class="mct-flex mct-justify-between mct-items-center">
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox name="DisplayExt" [(ngModel)]="profileData.DisplayExt" [binary]="true" inputId="displayExt"> </p-checkbox>
        <label for="displayExt">
          {{ 'common.personal-information.ext' | translate | titlecase }}
        </label>
      </div>
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox name="RequireExt" [(ngModel)]="profileData.RequireExt" [binary]="true" inputId="requireExt" class="mini-checkbox">
        </p-checkbox>
        <label for="requireExt" class="mr-5">
          {{ 'common.required' | translate | titlecase }}
        </label>
      </div>
    </div>
    <input name="ExtLabel" class="form-control" type="text" [(ngModel)]="profileData.ExtLabel" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mct-gap-5 mt-16">
    <div class="mct-flex mct-justify-between mct-items-center">
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox name="DisplayFax" [(ngModel)]="profileData.DisplayFax" [binary]="true" inputId="displayFax"> </p-checkbox>
        <label for="displayFax">
          {{ 'common.personal-information.fax' | translate | titlecase }}
        </label>
      </div>
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox name="RequireFax" [(ngModel)]="profileData.RequireFax" [binary]="true" inputId="requireFax" class="mini-checkbox">
        </p-checkbox>
        <label for="requireFax" class="mr-5">
          {{ 'common.required' | translate | titlecase }}
        </label>
      </div>
    </div>
    <input name="FaxLabel" class="form-control" type="text" [(ngModel)]="profileData.FaxLabel" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mct-gap-5 mt-16">
    <div class="mct-flex mct-justify-between mct-items-center">
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox name="DisplayEmail" [(ngModel)]="profileData.DisplayEmail" [binary]="true" inputId="displayEmail"> </p-checkbox>
        <label for="displayEmail">
          {{ 'common.personal-information.email' | translate | titlecase }}
        </label>
      </div>
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox name="RequireEmail" [(ngModel)]="profileData.RequireEmail" [binary]="true" inputId="requireEmail" class="mini-checkbox">
        </p-checkbox>
        <label for="requireEmail" class="mr-5">
          {{ 'common.required' | translate | titlecase }}
        </label>
      </div>
    </div>
    <input name="EmailLabel" class="form-control" type="text" [(ngModel)]="profileData.EmailLabel" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mt-16" *ngIf="isOrg">
    <div class="mct-flex mct-justify-between mct-items-center">
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox name="OrgWebsite" [(ngModel)]="profileData.DisplayWebsite" [binary]="true" inputId="displayWebsite"> </p-checkbox>
        <label for="displayWebsite">
          {{ 'common.personal-information.website' | translate | titlecase }}
        </label>
      </div>
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox
          name="RequireOrgWebsite"
          [(ngModel)]="profileData.RequireWebsite"
          [binary]="true"
          inputId="requireWebsite"
          class="mini-checkbox"
        >
        </p-checkbox>
        <label for="requireWebsite" class="mr-5">
          {{ 'common.required' | translate | titlecase }}
        </label>
      </div>
    </div>
    <input name="OrgWebsiteLabel" class="form-control" type="text" [(ngModel)]="profileData.WebsiteLabel" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mct-gap-5 mt-16" *ngIf="isOrg">
    <div class="mct-flex mct-justify-between mct-items-center">
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox
          name="DisplayFullTimeEmployees"
          [(ngModel)]="profileData.DisplayFullTimeEmployees"
          [binary]="true"
          inputId="displayFullTimeEmployees"
        >
        </p-checkbox>
        <label for="displayFullTimeEmployees">
          {{ 'form-builder.legos.profile.full-time-employees' | translate | titlecase }}
        </label>
      </div>
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox
          name="RequireFullTimeEmployees"
          [(ngModel)]="profileData.RequireFullTimeEmployees"
          [binary]="true"
          inputId="requireFullTimeEmployees"
          class="mini-checkbox"
        >
        </p-checkbox>
        <label for="requireFullTimeEmployees" class="mr-5">
          {{ 'common.required' | translate | titlecase }}
        </label>
      </div>
    </div>
    <input name="FullTimeEmployeesLabel" class="form-control" type="text" [(ngModel)]="profileData.FullTimeEmployeesLabel" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mct-col-start-1 mt-16" *ngIf="!isOrg">
    <div class="mct-flex mct-justify-between mct-items-center">
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox name="DisplayUserName" [(ngModel)]="profileData.DisplayUserName" [binary]="true" inputId="displayUserName"> </p-checkbox>
        <label for="displayUserName">
          {{ 'form-builder.legos.profile.username' | translate | titlecase }}
        </label>
      </div>
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox
          name="RequireUserName"
          [(ngModel)]="profileData.RequireUserName"
          [binary]="true"
          inputId="requireUserName"
          class="mini-checkbox"
        >
        </p-checkbox>
        <label for="requireUserName" class="mr-5">
          {{ 'common.required' | translate | titlecase }}
        </label>
      </div>
    </div>
    <input name="UserNameLabel" class="form-control" type="text" [(ngModel)]="profileData.UserNameLabel" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mct-gap-5 mt-16" *ngIf="!isOrg">
    <div class="mct-flex mct-justify-between mct-items-center">
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox name="DisplayPassword" [(ngModel)]="profileData.DisplayPassword" [binary]="true" inputId="displayPassword"> </p-checkbox>
        <label for="displayPassword">
          {{ 'form-builder.legos.profile.password' | translate | titlecase }}
        </label>
      </div>
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox
          name="RequirePassword"
          [(ngModel)]="profileData.RequirePassword"
          [binary]="true"
          inputId="requirePassword"
          class="mini-checkbox"
        >
        </p-checkbox>
        <label for="requirePassword" class="mr-5">
          {{ 'common.required' | translate | titlecase }}
        </label>
      </div>
    </div>
    <input name="PasswordLabel" class="form-control" type="text" [(ngModel)]="profileData.PasswordLabel" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mct-col-1-span-2-gt-sm mt-16">
    <div class="mct-flex mct-justify-between mct-items-center">
      <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
        <p-checkbox name="DisplayEmailOptIn" [(ngModel)]="profileData.DisplayEmailOptIn" [binary]="true" inputId="displayEmailOptIn">
        </p-checkbox>
        <label for="displayEmailOptIn">
          {{ 'form-builder.legos.email-optin.title' | translate | titlecase }}
        </label>
      </div>
    </div>
    <div>
      <wl-email-optin-lego-edit [emailOptInData]="profileData.EmailOptInMetaDataLego"></wl-email-optin-lego-edit>
    </div>
  </div>
</div>
